import BackToJobber from "./BackToJobber";
import JobberLogo from "./JobberLogo";
import Settings from "./Settings";
import styles from "./TopBar.module.scss";

const TopBar = () => {
  return (
    <div className={styles.container}>
      <JobberLogo url={"https://getjobber.com/"} />
      <BackToJobber url={"https://secure.getjobber.com/home"} />
      <Settings />
    </div>
  );
};

export default TopBar;
